/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/main.js":
/*!************************!*\
  !*** ./src/js/main.js ***!
  \************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
/**
 * Calculate cart total excluding free gift items
 * Checks DOM cart items with data-free-gift="true" and excludes their prices
 * @returns {Promise<number>} Cart total in cents excluding free gifts
 */
function getCartTotalExcludingFreeGifts() {
  return _getCartTotalExcludingFreeGifts.apply(this, arguments);
}
function _getCartTotalExcludingFreeGifts() {
  _getCartTotalExcludingFreeGifts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var response, cart, cartItems, freeGiftVariantIds, total, progressBar;
    return _regeneratorRuntime().wrap(function _callee5$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return fetch('/cart.js');
        case 3:
          response = _context6.sent;
          _context6.next = 6;
          return response.json();
        case 6:
          cart = _context6.sent;
          // Get all free gift variant IDs from DOM
          cartItems = document.querySelectorAll('.cart-item[data-free-gift="true"]');
          freeGiftVariantIds = Array.from(cartItems).map(function (item) {
            return item.dataset.variantId;
          }); // Calculate total excluding free gifts
          total = 0;
          cart.items.forEach(function (item) {
            var isFreeGift = freeGiftVariantIds.includes(String(item.variant_id));
            if (!isFreeGift) {
              total += item.final_line_price;
            }
          });
          return _context6.abrupt("return", total);
        case 14:
          _context6.prev = 14;
          _context6.t0 = _context6["catch"](0);
          console.error('Error calculating cart total excluding free gifts:', _context6.t0);
          // Fallback: return cart total from dataset if available
          progressBar = document.querySelector('progress-bar');
          if (!(progressBar && progressBar.dataset.cartTotal)) {
            _context6.next = 20;
            break;
          }
          return _context6.abrupt("return", Number.parseInt(progressBar.dataset.cartTotal));
        case 20:
          return _context6.abrupt("return", 0);
        case 21:
        case "end":
          return _context6.stop();
      }
    }, _callee5, null, [[0, 14]]);
  }));
  return _getCartTotalExcludingFreeGifts.apply(this, arguments);
}
if (!customElements.get('product-card')) {
  customElements.define('product-card', /*#__PURE__*/function (_HTMLElement) {
    _inherits(ProductForm, _HTMLElement);
    var _super = _createSuper(ProductForm);
    function ProductForm() {
      var _this;
      _classCallCheck(this, ProductForm);
      _this = _super.call(this);
      _this.form = _this.querySelector('form');
      _this.form.querySelector('[name=id]').disabled = false;
      _this.form.addEventListener('submit', _this.onSubmitHandler.bind(_assertThisInitialized(_this)));
      _this.cartNotification = document.querySelector('cart-notification');
      return _this;
    }
    _createClass(ProductForm, [{
      key: "onSubmitHandler",
      value: function onSubmitHandler(evt) {
        var _this2 = this;
        evt.preventDefault();
        var submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains('loading')) return;

        //this.handleErrorMessage();
        this.cartNotification.setActiveElement(document.activeElement);
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        var config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        var formData = new FormData(this.form);
        formData.append('sections', this.cartNotification.getSectionsToRender().map(function (section) {
          return section.id;
        }));
        formData.append('sections_url', window.location.pathname);
        config.body = formData;
        fetch("".concat(routes.cart_add_url), config).then(function (response) {
          return response.json();
        }).then(function (response) {
          if (response.status) {
            //this.handleErrorMessage(response.description);
            return;
          }
          _this2.cartNotification.renderContents(response);

          // Update progress bar after adding item to cart
          _this2.updateProgressBarAfterAdd();
        })["catch"](function (e) {
          console.error(e);
        })["finally"](function () {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          _this2.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
      }
    }, {
      key: "updateProgressBarAfterAdd",
      value: function updateProgressBarAfterAdd() {
        // Calculate cart total excluding free gifts
        getCartTotalExcludingFreeGifts().then(function (cartTotal) {
          var progressBar = document.querySelector('progress-bar');
          if (progressBar && typeof progressBar.updateCartTotal === 'function') {
            progressBar.updateCartTotal(cartTotal);
          }

          // Dispatch the same custom event for consistency
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: {
              cartTotal: cartTotal
            }
          }));
        })["catch"](function (e) {
          return console.error('Error updating progress bar:', e);
        });
      }
    }, {
      key: "handleErrorMessage",
      value: function handleErrorMessage() {
        var errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }]);
    return ProductForm;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLElement)));
}
var ProgressBar = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(ProgressBar, _HTMLElement2);
  var _super2 = _createSuper(ProgressBar);
  function ProgressBar() {
    var _this3;
    _classCallCheck(this, ProgressBar);
    _this3 = _super2.call(this);
    _this3.promotions = [];
    _this3.max = 0;
    // Keep cart total in cents (don't divide by 100) to match Shopify's format
    _this3.cartTotal = Number.parseInt(_this3.dataset.cartTotal);
    _this3.bar = _this3.querySelector("[data-bar]");
    _this3.message = _this3.querySelector("[data-message]");
    _this3.promotionsElement = _this3.querySelector("[data-badges]");
    _this3.proportion = _this3.dataset.proportion;
    _this3.processedFreeGifts = new Set(); // Track processed free gifts

    if (_this3.dataset.shipscoutEnabled === "true") {
      _this3.getShipScoutPromotions();
    } else {
      _this3.getThemePromotions();
    }
    _this3.buildProgressBar();
    _this3.observeTestSummaryChanges();
    _this3.checkFreeGiftPromotions();
    _this3.setupClaimAgainButton();
    return _this3;
  }
  _createClass(ProgressBar, [{
    key: "setupClaimAgainButton",
    value: function setupClaimAgainButton() {
      var _this4 = this;
      var claimAgainElement = this.querySelector('[data-claim-again]');
      if (claimAgainElement) {
        var button = claimAgainElement.querySelector('.progress-bar__claim-button');
        if (button) {
          button.addEventListener('click', function () {
            _this4.handleClaimAgainClick();
          });
        }
      }
    }
  }, {
    key: "handleClaimAgainClick",
    value: function handleClaimAgainClick() {
      // Clear rejected free gifts and re-check promotions
      this.clearAllRejectedFreeGifts();
      this.hideClaimAgainButton();
      // Re-check promotions to potentially add free gifts again
      this.checkFreeGiftPromotions();
    }
  }, {
    key: "showClaimAgainButton",
    value: function showClaimAgainButton() {
      var claimAgainElement = this.querySelector('[data-claim-again]');
      if (claimAgainElement) {
        claimAgainElement.classList.add('progress-bar__claim-again--visible');
      }
    }
  }, {
    key: "hideClaimAgainButton",
    value: function hideClaimAgainButton() {
      var claimAgainElement = this.querySelector('[data-claim-again]');
      if (claimAgainElement) {
        claimAgainElement.classList.remove('progress-bar__claim-again--visible');
      }
    }
  }, {
    key: "observeTestSummaryChanges",
    value: function observeTestSummaryChanges() {
      var _this5 = this;
      var observer = new MutationObserver(function (mutationsList) {
        var _iterator = _createForOfIteratorHelper(mutationsList),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var mutation = _step.value;
            if (mutation.attributeName === 'data-test-summary') {
              _this5.buildProgressBar();
            }
            _this5.removeDuplicateActiveBadges();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
      observer.observe(document.body, {
        attributes: true,
        childList: true,
        subtree: true
      });
    }
  }, {
    key: "removeDuplicateActiveBadges",
    value: function removeDuplicateActiveBadges() {
      if (!this.promotionsElement) return;
      var activeBadges = this.promotionsElement.querySelectorAll('.progress-bar__badge--active');
      if (activeBadges.length > 1) {
        activeBadges[0].remove();
      }
    }
  }, {
    key: "buildProgressBar",
    value: function buildProgressBar() {
      if (this.promotions.length === 0) return;
      this.sortAndSetActivePromotion();
      this.createStepsAndBadges();
      this.createProgressBar();
      this.displayMessage();
    }
  }, {
    key: "updateCartTotal",
    value: function updateCartTotal(newCartTotal) {
      // Keep cart total in cents to match Shopify's format
      this.cartTotal = Number.parseInt(newCartTotal);
      this.currentPromotion = null; // Reset current promotion
      this.buildProgressBar();
      this.checkFreeGiftPromotions(); // Check for free gifts when cart is updated
    }
  }, {
    key: "getThemePromotions",
    value: function getThemePromotions() {
      var promotions = this.querySelectorAll("[data-promotion]");
      // Create a Promotions Array of all the arrays.
      var _iterator2 = _createForOfIteratorHelper(promotions),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var promotion = _step2.value;
          // Convert threshold from dollars to cents (multiply by 100)
          var thresholdInDollars = Number.parseInt(promotion.dataset.threshold);
          var thresholdInCents = thresholdInDollars * 100;
          var promotionData = {
            title: promotion.dataset.title,
            threshold: thresholdInCents,
            messageText: promotion.dataset.messageText,
            type: promotion.dataset.type || 'standard',
            variantId: promotion.dataset.variantId,
            discountValue: promotion.dataset.discountValue
          };
          this.promotions.push(promotionData);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "getShipScoutPromotions",
    value: function getShipScoutPromotions() {
      if (window.shipscoutTestObject == null) return;
      this.promotions.push(window.shipscoutTestObject);
    }
  }, {
    key: "sortAndSetActivePromotion",
    value: function sortAndSetActivePromotion() {
      var _this6 = this;
      // Sort Promotions Array in ascending order based on thresholds.
      function compare(a, b) {
        if (a.threshold < b.threshold) {
          return -1;
        }
        if (a.threshold > b.threshold) {
          return 1;
        }
        return 0;
      }
      this.promotions.sort(compare);

      // Find max threshold, find current promotion.
      this.promotions.forEach(function (promotion) {
        if (promotion.threshold <= _this6.cartTotal) {
          promotion.active = true;
        } else {
          promotion.active = false;
          if (_this6.currentPromotion == null) {
            _this6.currentPromotion = promotion;
          }
        }
        if (_this6.max < promotion.threshold) {
          _this6.max = promotion.threshold;
        }
      });
    }
  }, {
    key: "displayMessage",
    value: function displayMessage() {
      var _currencyMap$Shopify$;
      var currencyMap = {
        CAD: "$",
        USD: "$"
      };
      var currencySymbol = (_currencyMap$Shopify$ = currencyMap[Shopify.currency.active]) !== null && _currencyMap$Shopify$ !== void 0 ? _currencyMap$Shopify$ : Shopify.currency.active;
      if (this.currentPromotion != null) {
        // Convert cents to dollars for display
        var remainingAmount = (this.currentPromotion.threshold - this.cartTotal) / 100;
        this.message.innerHTML = "Spend <span class=\"font-bold\"><span class=\"currency-symbol\">".concat(currencySymbol, "</span>").concat(Math.ceil(remainingAmount), "</span> to get <span class=\"font-bold\">").concat(this.currentPromotion.messageText, "</span>");
      } else {
        this.message.innerHTML = "Congratulations! You've earned <span class=\"font-bold\">".concat(this.promotions[this.promotions.length - 1].messageText, "</span>");
      }
    }
  }, {
    key: "updateTargetBadge",
    value: function updateTargetBadge() {
      // Remove the old single badge approach - we'll handle multiple badges in createStepsAndBadges
      return;
    }
  }, {
    key: "createStepsAndBadges",
    value: function createStepsAndBadges() {
      var _this7 = this;
      // Clear existing steps and badges
      this.bar.querySelectorAll('.progress-bar__step').forEach(function (step) {
        return step.remove();
      });
      this.bar.querySelectorAll('.progress-bar__badge').forEach(function (badge) {
        return badge.remove();
      });
      if (this.promotionsElement) {
        this.promotionsElement.innerHTML = '';
      }
      var fragment = document.createDocumentFragment();
      this.promotions.forEach(function (promotion, i) {
        // Create step markers (between promotions, not at the end)
        if (i < _this7.promotions.length - 1) {
          var step = document.createElement("div");
          step.classList.add("progress-bar__step");
          var _left = _this7.proportion === "equidistant" ? (i + 1) / _this7.promotions.length * 100 : promotion.threshold / _this7.max * 100;
          step.style.left = "".concat(_left, "%");
          step.style.transform = "translate(-50%, -50%)";
          _this7.bar.append(step);
        }

        // Create badges positioned along the progress bar
        var promotionBadge = document.createElement("div");
        promotionBadge.classList.add("progress-bar__badge");

        // Position badge along the progress bar
        var left = _this7.proportion === "equidistant" ? (i + 1) / _this7.promotions.length * 100 : promotion.threshold / _this7.max * 100;
        promotionBadge.style.position = "absolute";
        promotionBadge.style.left = "".concat(left, "%");
        promotionBadge.style.top = "50%";
        promotionBadge.style.transform = "translate(-50%, -50%)";
        promotionBadge.style.zIndex = "2";

        // Add appropriate styling and icon based on promotion status
        if (promotion.active) {
          promotionBadge.classList.add("progress-bar__badge--achieved");
          promotionBadge.innerHTML = "\n          <div class=\"progress-bar__badge-reward\">".concat(promotion.title, "</div>\n          <svg width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n            <path d=\"M 18 1 C 14.67619 1 12 3.6761905 12 7 L 12 8 L 1 8 L 1 22 L 16 22 L 16 8 L 14 8 L 14 7 C 14 4.7238095 15.72381 3 18 3 C 20.27619 3 22 4.7238095 22 7 L 22 9 L 24 9 L 24 7 C 24 3.6761905 21.32381 1 18 1 z M 8.5078125 13 C 9.6078125 13 10.507812 13.9 10.507812 15 C 10.507812 16.1 9.6078125 17 8.5078125 17 C 7.4078125 17 6.5078125 16.1 6.5078125 15 C 6.5078125 13.9 7.4078125 13 8.5078125 13 z\" fill=\"currentColor\"/>\n          </svg>\n        ");
        } else {
          promotionBadge.classList.add("progress-bar__badge--pending");
          promotionBadge.innerHTML = "\n          <div class=\"progress-bar__badge-reward\">".concat(promotion.title, "</div>\n          <svg width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n            <path d=\"M 12 1 C 8.6761905 1 6 3.6761905 6 7 L 6 8 L 4 8 L 4 22 L 20 22 L 20 8 L 18 8 L 18 7 C 18 3.6761905 15.32381 1 12 1 z M 12 3 C 14.27619 3 16 4.7238095 16 7 L 16 8 L 8 8 L 8 7 C 8 4.7238095 9.7238095 3 12 3 z M 12 13 C 13.1 13 14 13.9 14 15 C 14 16.1 13.1 17 12 17 C 10.9 17 10 16.1 10 15 C 10 13.9 10.9 13 12 13 z\" fill=\"currentColor\"/>\n          </svg>\n        ");
        }

        // Add badge to the progress bar
        _this7.bar.append(promotionBadge);

        // Also add to hidden promotionsElement for backward compatibility
        var hiddenPromotionBadge = document.createElement("div");
        hiddenPromotionBadge.classList.add("progress-bar__badge");
        if (promotion.active) hiddenPromotionBadge.classList.add("progress-bar__badge--active");
        hiddenPromotionBadge.innerHTML = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g><path class=\"progress-bar__checkmark-circle\" d=\"M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3Z\" stroke=\"black\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path class=\"progress-bar__checkmark\" d=\"M15.142 9.98299L10.875 14.25L9.42049 12.7955\" stroke=\"black\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></g></svg>";
        var promotionBadgeTitle = document.createElement("div");
        promotionBadgeTitle.innerText = promotion.title;
        hiddenPromotionBadge.appendChild(promotionBadgeTitle);
        fragment.appendChild(hiddenPromotionBadge);
      });
      if (this.promotionsElement != null) {
        this.promotionsElement.appendChild(fragment);
      }
    }
  }, {
    key: "createProgressBar",
    value: function createProgressBar() {
      var innerProgressBar = document.querySelector('.progress-bar__inner-bar') || document.createElement("div");
      innerProgressBar.classList.add("progress-bar__inner-bar");
      var width = 0;
      if (this.proportion === "equidistant") {
        var currentThreshold = 0;
        for (var i = 0; i < this.promotions.length; i++) {
          if (this.promotions[i].active) {
            width += 100 / this.promotions.length;
            currentThreshold = this.promotions[i].threshold;
          } else {
            width += (this.cartTotal - currentThreshold) / (this.promotions[i].threshold - currentThreshold) * (100 / this.promotions.length);
            break;
          }
        }
      } else {
        width = this.cartTotal / this.max * 100;
      }
      innerProgressBar.style.width = "".concat(width >= 100 ? 100 : width, "%");
      this.bar.append(innerProgressBar);
    }
  }, {
    key: "checkFreeGiftPromotions",
    value: function checkFreeGiftPromotions() {
      var _this8 = this;
      var hasRejectedEligibleGifts = false;

      // Get cart total excluding free gifts
      getCartTotalExcludingFreeGifts().then(function (cartTotalExcludingFreeGifts) {
        // Check each promotion to see if it should be triggered
        _this8.promotions.forEach(function (promotion) {
          if (promotion.type === 'free_gift' && promotion.variantId) {
            var thresholdMet = cartTotalExcludingFreeGifts >= promotion.threshold;
            var alreadyProcessed = _this8.processedFreeGifts.has(promotion.threshold);
            var isRejected = _this8.isGiftRejected(promotion.variantId);
            if (thresholdMet && !alreadyProcessed && !isRejected) {
              // Only add to processed set if we're actually going to handle the gift
              _this8.processedFreeGifts.add(promotion.threshold);
              _this8.handleFreeGift(promotion);
            } else if (thresholdMet && isRejected) {
              // If the gift was rejected but threshold is still met, show claim again button
              hasRejectedEligibleGifts = true;
              console.log('Free gift variant', promotion.variantId, 'threshold met but was rejected by user');
            }
          } else if (cartTotalExcludingFreeGifts >= promotion.threshold && !_this8.processedFreeGifts.has(promotion.threshold)) {
            // Handle non-free-gift promotions as before
            _this8.processedFreeGifts.add(promotion.threshold);
          }
        });

        // Show or hide claim again button based on rejected eligible gifts
        if (hasRejectedEligibleGifts) {
          _this8.showClaimAgainButton();
        } else {
          _this8.hideClaimAgainButton();
        }

        // Check if we need to remove free gifts when threshold is no longer met
        _this8.checkAndRemoveFreeGifts();
      })["catch"](function (error) {
        console.error('Error checking free gift promotions:', error);
      });
    }
  }, {
    key: "handleFreeGift",
    value: function handleFreeGift(promotion) {
      var _this9 = this;
      // Check if this free gift has been rejected by the user
      if (this.isGiftRejected(promotion.variantId)) {
        console.log('Free gift variant', promotion.variantId, 'was rejected by user, skipping auto-add');
        return;
      }

      // Check if free gift is already in cart
      this.checkIfFreeGiftInCart(promotion.variantId).then(function (inCart) {
        if (!inCart) {
          _this9.addFreeGiftToCart(promotion.variantId, promotion.title);
        }
      })["catch"](function (error) {
        console.error('Error checking free gift in cart:', error);
      });
    }
  }, {
    key: "isGiftRejected",
    value: function isGiftRejected(variantId) {
      try {
        // Simple check: look for single session storage key
        return sessionStorage.getItem("rejected_free_gift") === 'true';
      } catch (error) {
        console.error('Error checking rejected free gifts:', error);
        return false;
      }
    }
  }, {
    key: "checkIfFreeGiftInCart",
    value: function () {
      var _checkIfFreeGiftInCart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(variantId) {
        var cartItems;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              // Check the DOM cart items instead of relying on cart API tags
              cartItems = document.querySelectorAll('.cart-item');
              return _context.abrupt("return", Array.from(cartItems).some(function (cartItem) {
                var itemVariantId = cartItem.dataset.variantId;
                var isFreeGift = cartItem.dataset.freeGift === 'true';
                return itemVariantId === variantId && isFreeGift;
              }));
            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              console.error('Error checking free gift in cart:', _context.t0);
              return _context.abrupt("return", false);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 5]]);
      }));
      function checkIfFreeGiftInCart(_x) {
        return _checkIfFreeGiftInCart.apply(this, arguments);
      }
      return checkIfFreeGiftInCart;
    }()
  }, {
    key: "addFreeGiftToCart",
    value: function () {
      var _addFreeGiftToCart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(variantId, giftTitle) {
        var updateData, updateResponse;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              // Show loading indicator
              this.showLoadingIndicator();
              updateData = {
                updates: _defineProperty({}, parseInt(variantId), 1)
              };
              _context2.next = 5;
              return fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(updateData)
              });
            case 5:
              updateResponse = _context2.sent;
              if (updateResponse.ok) {
                console.log('Free gift added/updated to quantity 1');
              } else {
                console.error('Failed to update free gift');
              }

              // Refresh the cart section or page
              setTimeout(function () {
                window.location.reload();
              }, 1000);
              _context2.next = 14;
              break;
            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](0);
              console.error('Error adding free gift to cart:', _context2.t0);
              // Hide loading indicator on error
              this.hideLoadingIndicator();
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 10]]);
      }));
      function addFreeGiftToCart(_x2, _x3) {
        return _addFreeGiftToCart.apply(this, arguments);
      }
      return addFreeGiftToCart;
    }()
  }, {
    key: "showLoadingIndicator",
    value: function showLoadingIndicator() {
      var loadingElement = this.querySelector('[data-loading]');
      if (loadingElement) {
        loadingElement.classList.add('progress-bar__loading--visible');
      }
    }
  }, {
    key: "hideLoadingIndicator",
    value: function hideLoadingIndicator() {
      var loadingElement = this.querySelector('[data-loading]');
      if (loadingElement) {
        loadingElement.classList.remove('progress-bar__loading--visible');
      }
    }
  }, {
    key: "checkAndRemoveFreeGifts",
    value: function () {
      var _checkAndRemoveFreeGifts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this10 = this;
        var cartTotalExcludingFreeGifts, _iterator3, _step3, _loop, _ret;
        return _regeneratorRuntime().wrap(function _callee3$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return getCartTotalExcludingFreeGifts();
            case 3:
              cartTotalExcludingFreeGifts = _context4.sent;
              // Check each promotion to see if its threshold is still met
              _iterator3 = _createForOfIteratorHelper(this.promotions);
              _context4.prev = 5;
              _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
                var promotion, cartItems, freeGiftItem;
                return _regeneratorRuntime().wrap(function _loop$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      promotion = _step3.value;
                      if (!(promotion.type === 'free_gift' && promotion.variantId)) {
                        _context3.next = 10;
                        break;
                      }
                      // Check DOM cart items instead of cart API
                      cartItems = document.querySelectorAll('.cart-item');
                      freeGiftItem = Array.from(cartItems).find(function (cartItem) {
                        var itemVariantId = cartItem.dataset.variantId;
                        var isFreeGift = cartItem.dataset.freeGift === 'true';
                        return itemVariantId === promotion.variantId && isFreeGift;
                      }); // Use cart total excluding free gifts for threshold comparison
                      if (!(freeGiftItem && cartTotalExcludingFreeGifts < promotion.threshold)) {
                        _context3.next = 10;
                        break;
                      }
                      _context3.next = 7;
                      return _this10.removeFreeGiftFromCart(promotion.variantId, promotion.title);
                    case 7:
                      // Remove from processed set so it can be added again when threshold is reached
                      _this10.processedFreeGifts["delete"](promotion.threshold);
                      // Also remove from rejected list since it's being auto-removed due to threshold
                      _this10.removeFromRejectedFreeGifts(promotion.variantId);

                      // Only handle one free gift at a time, so break after removing
                      return _context3.abrupt("return", "break");
                    case 10:
                    case "end":
                      return _context3.stop();
                  }
                }, _loop);
              });
              _iterator3.s();
            case 8:
              if ((_step3 = _iterator3.n()).done) {
                _context4.next = 15;
                break;
              }
              return _context4.delegateYield(_loop(), "t0", 10);
            case 10:
              _ret = _context4.t0;
              if (!(_ret === "break")) {
                _context4.next = 13;
                break;
              }
              return _context4.abrupt("break", 15);
            case 13:
              _context4.next = 8;
              break;
            case 15:
              _context4.next = 20;
              break;
            case 17:
              _context4.prev = 17;
              _context4.t1 = _context4["catch"](5);
              _iterator3.e(_context4.t1);
            case 20:
              _context4.prev = 20;
              _iterator3.f();
              return _context4.finish(20);
            case 23:
              _context4.next = 28;
              break;
            case 25:
              _context4.prev = 25;
              _context4.t2 = _context4["catch"](0);
              console.error('Error checking and removing free gifts:', _context4.t2);
            case 28:
            case "end":
              return _context4.stop();
          }
        }, _callee3, this, [[0, 25], [5, 17, 20, 23]]);
      }));
      function checkAndRemoveFreeGifts() {
        return _checkAndRemoveFreeGifts.apply(this, arguments);
      }
      return checkAndRemoveFreeGifts;
    }()
  }, {
    key: "removeFreeGiftFromCart",
    value: function () {
      var _removeFreeGiftFromCart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(variantId, itemTitle) {
        var updateData, response, cartResponse, cart;
        return _regeneratorRuntime().wrap(function _callee4$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              updateData = {
                updates: _defineProperty({}, parseInt(variantId), 0)
              };
              _context5.next = 4;
              return fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(updateData)
              });
            case 4:
              response = _context5.sent;
              if (!response.ok) {
                _context5.next = 17;
                break;
              }
              console.log("Free gift \"".concat(itemTitle, "\" removed from cart - threshold no longer met"));

              // Refresh the cart by reloading the page or dispatching cart update event
              // Get updated cart total
              _context5.next = 9;
              return fetch('/cart.js');
            case 9:
              cartResponse = _context5.sent;
              _context5.next = 12;
              return cartResponse.json();
            case 12:
              cart = _context5.sent;
              // Dispatch cart updated event to refresh cart sections
              document.dispatchEvent(new CustomEvent('cart:updated', {
                detail: {
                  cartTotal: cart.total_price
                }
              }));

              // Refresh the page to ensure all cart sections are updated
              window.location.reload();
              _context5.next = 18;
              break;
            case 17:
              console.error('Failed to remove free gift from cart');
            case 18:
              _context5.next = 23;
              break;
            case 20:
              _context5.prev = 20;
              _context5.t0 = _context5["catch"](0);
              console.error('Error removing free gift from cart:', _context5.t0);
            case 23:
            case "end":
              return _context5.stop();
          }
        }, _callee4, null, [[0, 20]]);
      }));
      function removeFreeGiftFromCart(_x4, _x5) {
        return _removeFreeGiftFromCart.apply(this, arguments);
      }
      return removeFreeGiftFromCart;
    }()
  }, {
    key: "showFreeGiftNotification",
    value: function showFreeGiftNotification(productTitle) {
      // Create notification element
      var notification = document.createElement('div');
      notification.className = 'progress-bar__free-gift-notification';
      notification.innerHTML = "\n      <div class=\"progress-bar__free-gift-content\">\n        <span>\uD83C\uDF81 Free gift \"<strong>".concat(productTitle, "</strong>\" has been added to your cart!</span>\n        <button class=\"progress-bar__discount-close\" onclick=\"this.parentElement.parentElement.remove()\">\xD7</button>\n      </div>\n    ");

      // Insert after progress bar container
      var progressBarContainer = this.closest('.progress-bar-container');
      if (progressBarContainer && progressBarContainer.parentNode) {
        progressBarContainer.parentNode.insertBefore(notification, progressBarContainer.nextSibling);
      } else {
        // Fallback: insert after the progress bar element itself
        this.parentNode.insertBefore(notification, this.nextSibling);
      }

      // Auto-remove after 5 seconds
      setTimeout(function () {
        if (notification.parentNode) {
          notification.remove();
        }
      }, 5000);
    }
  }, {
    key: "removeFromRejectedFreeGifts",
    value: function removeFromRejectedFreeGifts(variantId) {
      try {
        // Simple removal: just remove the single session storage key
        sessionStorage.removeItem("rejected_free_gift");
        console.log('Free gift variant', variantId, 'removed from rejected list due to threshold change');
      } catch (error) {
        console.error('Error removing from rejected free gifts:', error);
      }
    }

    // Utility method to clear all rejected free gifts (can be called manually if needed)
  }, {
    key: "clearAllRejectedFreeGifts",
    value: function clearAllRejectedFreeGifts() {
      var _this11 = this;
      try {
        // Clear the single rejected free gift flag
        sessionStorage.removeItem('rejected_free_gift');

        // Also clear processed gifts for free gift promotions so they can be offered again
        this.promotions.forEach(function (promotion) {
          if (promotion.type === 'free_gift' && promotion.variantId) {
            _this11.processedFreeGifts["delete"](promotion.threshold);
          }
        });
        console.log('All rejected free gifts cleared from session storage and processed gifts reset');
        // Re-check promotions in case any should be triggered now
        this.checkFreeGiftPromotions();
      } catch (error) {
        console.error('Error clearing rejected free gifts:', error);
      }
    }

    // Handle when a free gift is manually rejected by the user
  }, {
    key: "handleGiftRejection",
    value: function handleGiftRejection(variantId) {
      try {
        // Find the promotion associated with this variant ID
        var rejectedPromotion = this.promotions.find(function (promotion) {
          return promotion.type === 'free_gift' && promotion.variantId === variantId;
        });
        if (rejectedPromotion) {
          // Remove from processed gifts so it can be offered again if user changes their mind later
          this.processedFreeGifts["delete"](rejectedPromotion.threshold);
          console.log('Free gift threshold', rejectedPromotion.threshold, 'removed from processed list due to user rejection');
        }
      } catch (error) {
        console.error('Error handling gift rejection:', error);
      }
    }

    // Debug method to see current state (can be called from console)
  }, {
    key: "debugFreeGiftState",
    value: function debugFreeGiftState() {
      console.log('=== Free Gift Debug State ===');
      console.log('Cart Total:', this.cartTotal);
      console.log('Processed Free Gifts (thresholds):', Array.from(this.processedFreeGifts));
      console.log('Rejected Free Gifts:', sessionStorage.getItem('rejected_free_gift') === 'true' ? 'YES' : 'NO');
      console.log('Free Gift Promotions:', this.promotions.filter(function (p) {
        return p.type === 'free_gift';
      }));
      console.log('=============================');
    }
  }]);
  return ProgressBar;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("progress-bar", ProgressBar);

// Add event listener to update progress bar on page load/refresh
document.addEventListener('DOMContentLoaded', function () {
  // Function to update progress bar with current cart state
  function updateProgressBarFromCart() {
    var progressBar = document.querySelector('progress-bar');
    if (progressBar) {
      // Get cart total excluding free gifts
      getCartTotalExcludingFreeGifts().then(function (cartTotalExcludingFreeGifts) {
        if (cartTotalExcludingFreeGifts > 0 && typeof progressBar.updateCartTotal === 'function') {
          progressBar.updateCartTotal(cartTotalExcludingFreeGifts);
        }
      })["catch"](function (error) {
        console.error('Error fetching cart for progress bar update:', error);
        // Fallback to progress bar's current dataset
        if (progressBar.dataset.cartTotal) {
          var cartTotal = progressBar.dataset.cartTotal;
          if (typeof progressBar.updateCartTotal === 'function') {
            progressBar.updateCartTotal(cartTotal);
          }
        }
      });
    }
  }

  // Small delay to ensure cart data is available
  setTimeout(updateProgressBarFromCart, 100);

  // Also listen for when progress bar is ready
  if (customElements.get('progress-bar')) {
    updateProgressBarFromCart();
  } else {
    customElements.whenDefined('progress-bar').then(updateProgressBarFromCart);
  }
});

// Listen for cart updates and update progress bar accordingly
document.addEventListener('cart:updated', function (event) {
  // Small delay to ensure DOM is updated
  setTimeout(function () {
    var progressBar = document.querySelector('progress-bar');
    if (progressBar && typeof progressBar.updateCartTotal === 'function') {
      // Get cart total excluding free gifts
      getCartTotalExcludingFreeGifts().then(function (cartTotalExcludingFreeGifts) {
        progressBar.updateCartTotal(cartTotalExcludingFreeGifts);
      })["catch"](function (error) {
        console.error('Error fetching cart for progress bar update:', error);
      });
    }
  }, 50);
});

/***/ }),

/***/ "./src/scss/sr-custom.scss":
/*!*********************************!*\
  !*** ./src/scss/sr-custom.scss ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/main": 0,
/******/ 			"assets/sr-custom": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkhandee"] = self["webpackChunkhandee"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/sr-custom"], () => (__webpack_require__("./src/js/main.js")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/sr-custom"], () => (__webpack_require__("./src/scss/sr-custom.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;